<div class="container-fluid main-container">
  <div class="row justify-content-md-center title-container">
    <div class="col">
      <h1>Police d'assurance</h1>
    </div>
  </div>
  <div class="row justify-content-md-center text-center">
    <div class="col mb-3 p-5">
      <a href="/content/documents/CG_Terrestre.pdf" target="_blank">Poilce d'assurance</a>
    </div>
  </div>
</div>
